import { useNonF2fMedicalCategories } from '@/entities/medical-category';
import { MedicalCategoryModel } from '@/entities/medical-category/model/MedicalCategory';

import { getCategoryPath as getTelemedicineCategoryPath, useTelemedicineRequest } from '@/entities/telemedicine';
import { ROUTES } from '@/types/common';
import { MEDICAL_CATEGORY_CONFIG } from '../lib/constants';

const MORE_CATEGORY_PATH = `${ROUTES.TELEMEDICINE.CATEGORIES.path}`;

const MORE_CATEGORY = {
  id: 'more',
  name: '전체 보기',
  iconUrl: 'https://d2m9duoqjhyhsq.cloudfront.net/diagnoses/etc/more_category.png',
};

const useMedicalCategoryDisplayViewModel = (size = MEDICAL_CATEGORY_CONFIG.DEFAULT_DISPLAY_SIZE - 1) => {
  const { onClickTelemedicineRequest } = useTelemedicineRequest();
  const { medicalCategories, isLoading, error } = useNonF2fMedicalCategories(size);

  const getCategoryPath = (category: MedicalCategoryModel) => {
    return getTelemedicineCategoryPath(category.id, category.category);
  };

  const onClickCategory = (category: MedicalCategoryModel) => {
    onClickTelemedicineRequest({
      categoryId: category.id,
      type: category.category,
      redirectUrl: getTelemedicineCategoryPath(category.id, category.category),
    });
  };

  return {
    medicalCategories: medicalCategories,
    moreCategory: MORE_CATEGORY,
    isLoading,
    error,
    moreCategoryPath: MORE_CATEGORY_PATH,
    getCategoryPath,
    onClickCategory,
  };
};

export default useMedicalCategoryDisplayViewModel;
